<div class="container titulo-box">
  <div class="row m-none">
    <h2 mat-dialog-title class="mc-vert-tb">Eliminar cuenta Yacaré</h2>
  </div>
</div>

<mat-dialog-content>
  <div class="container mt-2">
    <div class="row mt-2 mb-2">
      <div class="col-12 mt-3 mb-3 text-center">
        <div *ngIf="confirmed; else warning">
          <p class="dialog-text">Ingresá tu contraseña</p>
          <form [formGroup]="form">
            <mat-form-field appearance="outline" class="mb-2 dialog-input">
              <mat-label>Contraseña</mat-label>
              <input matInput type="{{ passwordType }}" formControlName="password" />
              <mat-icon matSuffix *ngIf="passwordType === 'password'" (click)="togglePassword()" class="pointer"
                >visibility_off</mat-icon
              >
              <mat-icon matSuffix *ngIf="passwordType === 'text'" (click)="togglePassword()" class="pointer">
                visibility</mat-icon
              >
            </mat-form-field>
          </form>
        </div>
        <ng-template #warning>
          <p class="dialog-text">Su cuenta Yacaré será eliminada definitivamente. ¿Desea continuar?</p>
        </ng-template>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="mb-2">
  <div class="row m-none align-items-center m-0">
    <button mat-stroked-button [mat-dialog-close]="false" color="secondary" class="mr-2 w-button button-cancel">
      Cancelar
    </button>
    <button
      mat-raised-button
      color="primary"
      [ngClass]="{ 'mr-2 w-button button-actions': !checking }"
      (click)="deleteAccount()"
      [disabled]="checking"
      *ngIf="confirmed"
    >
      Aceptar
    </button>
    <button
      mat-raised-button
      color="primary"
      class="mr-2 w-button button-actions"
      (click)="confirmed = true"
      *ngIf="!confirmed"
    >
      Confirmar
    </button>
    <div class="mr-2 w-button spinner">
      <mat-spinner *ngIf="deletingAccount" [diameter]="20"></mat-spinner>
    </div>
  </div>
</mat-dialog-actions>
